import { render } from "./access-denied.vue?vue&type=template&id=8768e64a"
import script from "./access-denied.vue?vue&type=script&lang=js"
export * from "./access-denied.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__